import { h } from './dom.ts';

/**
 * In-app text size (FR-UX-08): bigger words everywhere and bigger rank/suit marks on cards,
 * while the cards keep their size. The iOS app remembers the choice natively and passes it in
 * as CAMPFIRE_TEXT; plain browsers keep it for the session only (no browser storage).
 */
export const TEXT_SIZES = [
  { id: 'normal', text: 1, mark: 1, label: 'Text size: normal' },
  { id: 'large', text: 1.2, mark: 1.3, label: 'Text size: large' },
  { id: 'huge', text: 1.4, mark: 1.6, label: 'Text size: extra large' },
] as const;

type Native = { webkit?: { messageHandlers?: { textSize?: { postMessage(v: string): void } } }; CAMPFIRE_TEXT?: string };
const g = globalThis as Native;
let index = Math.max(0, TEXT_SIZES.findIndex((s) => s.id === g.CAMPFIRE_TEXT));

export function applyTextSize(): void {
  const s = TEXT_SIZES[index] ?? TEXT_SIZES[0];
  const root = document.documentElement;
  root.style.setProperty('--text-scale', String(s.text));
  root.style.setProperty('--mark-scale', String(s.mark));
  root.dataset['textSize'] = s.id;
}

/** A floating "Aa" button that cycles normal → large → extra large. */
export function mountTextSizeButton(): void {
  const button = h('button.textsize', { 'data-testid': 'text-size', 'aria-label': TEXT_SIZES[index]?.label ?? '' }, 'Aa') as HTMLButtonElement;
  button.addEventListener('click', () => {
    index = (index + 1) % TEXT_SIZES.length;
    applyTextSize();
    const s = TEXT_SIZES[index] ?? TEXT_SIZES[0];
    button.setAttribute('aria-label', s.label);
    g.webkit?.messageHandlers?.textSize?.postMessage(s.id);
  });
  document.body.append(button);
  applyTextSize();
}
